import React, { FC } from 'react';
import { Row, Typography } from 'components';
import { Badge } from 'antd';
import styles from './styles.module.scss';

const { Text } = Typography;

export type SupplierOfferStatusType = 'DRAFT' | 'PUBLISH';

type StatusMapType = {
  label: string;
  color: string;
  dotColor: string;
};

export const SUPPLIER_OFFER_STATUS_MAPPING: Record<SupplierOfferStatusType, StatusMapType> = {
  DRAFT: {
    label: 'Draft',
    color: '#E5E8EE',
    dotColor: '#71767F',
  },
  PUBLISH: {
    label: 'Publish',
    color: '#E0FAE1',
    dotColor: '#44AE6F',
  },
};

interface IStatusBadge {
  tooltip?: string;
  type: SupplierOfferStatusType;
}

export const SupplierOfferStatusBadge: FC<IStatusBadge> = React.memo((props) => {
  const { type } = props;

  const status = SUPPLIER_OFFER_STATUS_MAPPING[type as SupplierOfferStatusType];

  return (
    <Row
      className={styles.badge}
      style={{ border: 'none', color: status.dotColor, backgroundColor: status.color }}
      align={'middle'}
    >
      <Badge color={status.dotColor} />
      <Text style={{ color: status.dotColor, fontSize: 12, fontWeight: 500 }}>{status.label}</Text>
    </Row>
  );
});
